<template>
  <div>
    <div
      class="sub-header success-details"
      data-test="sub-header"
    >
      Thank you for completing your donor profile!
    </div>
    <h5
      class="helping-text details text-base"
      data-test="helping-text"
    >
      You can update your personal information and manage your preferences at any time from the Settings tab.
    </h5>
  </div>
</template>
